import { Filter, FilterGroup } from "../types/types";

const sanitizeValue = (value: string | number | boolean) => {
    return value.toString().toLowerCase().replaceAll('\'', '\'\'');
}

export const GenerateODataFilter = (filters: (Filter | FilterGroup)[], join?: 'and' | 'or'): string | undefined => {

    let filterString = "";
    let filterCombined: string[] = [];
    if (!join) {
        join = 'and';
    }

    filters.forEach((filter) => {
        if (filter.type === "group") {
            filterCombined.push("(" + GenerateODataFilter(filter.filters, filter.join) + ")");
        } else {
            if (filter.values.length > 0) {
                let filterValues: string[] = [];

                switch (filter.type) {
                    case "search":

                        [...filter.property.split(",")].forEach(property => {
                            filter.values.forEach((value, valueindex) => {
                                if (property.indexOf(".") > 0) {
                                    var props = property.split(".")
                                    let propPath = props.slice(0, props.length - 1).join("/") + "/any";

                                    if (value.value.toString().indexOf(",") > 0) {
                                        var values = value.value.toString().split(",");
                                        if(filter.caseSensitive){
                                            propPath += `(p/Name eq '${props[props.length - 1].toLowerCase()}' and ${values.reduce((prev, curr, index) => prev += `${index > 0 ? ` or ` : ``}contains(p/Value,'${sanitizeValue(curr)}')`, "")})`;
                                        }else{
                                            propPath += `(p:tolower(p/Name) eq '${props[props.length - 1].toLowerCase()}' and ${values.reduce((prev, curr, index) => prev += `${index > 0 ? ` or ` : ``}contains(tolower(p/Value),'${sanitizeValue(curr)}')`, "")})`;
                                        }
                                    } else {
                                        if(filter.caseSensitive){
                                            propPath += `(p:p/Name eq '${props[props.length - 1].toLowerCase()}' and contains(p/Value,'${sanitizeValue(value.value)}'))`;
                                        }else{
                                            propPath += `(p:tolower(p/Name) eq '${props[props.length - 1].toLowerCase()}' and contains(tolower(p/Value),'${sanitizeValue(value.value)}'))`;
                                        }
                                    }

                                    filterValues.push(propPath);
                                } else if (property.includes("[") && property.includes("]")) {
                                    let path = property.substring(0, property.indexOf("["));
                                    let subproperty = property.substring(property.indexOf("[") + 1, property.indexOf("]"));


                                    filterValues.push(`${path}/any(p:contains(tolower(p/${subproperty}),'${sanitizeValue(value.value)}'))`)

                                } else {
                                    filterValues.push(`contains(tolower(${property}),'${sanitizeValue(value.value)}')`);
                                }
                            });
                        });

                        filterCombined.push(`(${filterValues.join(" or ")})`)

                        break;
                    case "select":

                        [...filter.property.split(",")].forEach(property => {
                            filter.values.forEach((value, valueindex) => {

                                let val = value.value;
                                if (typeof val === 'boolean') {
                                    val = val.toString();
                                } else if (typeof val !== 'number') {
                                    val = `'${sanitizeValue(val)}'`;
                                }

                                const comparison = filter.negate ? "ne" : "eq";

                                var propertyPath = `${property} ${comparison} ${val}`;
                                if (property.indexOf(".") > 0) {
                                    var props = property.split(".")
                                    propertyPath = props.slice(0, props.length - 1).join("/") + "/any";
                                    if(filter.caseSensitive){
                                        propertyPath += `(p:p/Name eq '${props[props.length - 1].toLowerCase()}' and p/Value ${comparison} ${val})`
                                    }else{
                                        propertyPath += `(p:tolower(p/Name) eq '${props[props.length - 1].toLowerCase()}' and tolower(p/Value) ${comparison} ${val})`
                                    }
                                }

                                filterValues.push(propertyPath);
                            });
                        });

                        filterCombined.push(`(${filterValues.join(" or ")})`)

                        break;

                    case "daterange":

                        filter.values.forEach((value, valueindex) => {
                            const comparer = (valueindex === 1) ? "lt" : "gt";
                            const dateValue = new Date(parseInt(value.value.toString())).toISOString()
                            filterValues.push(`${filter.property} ${comparer} ${dateValue}`);
                        });

                        filterCombined.push(`(${filterValues.join(" and ")})`)

                        break;

                    default:
                        const comparison = filter.negate ? "ne" : "eq";

                        filter.values.forEach(value => {
                            filterValues.push(`${filter.property} ${comparison} ${sanitizeValue(value.value)}`);
                        });

                        filterCombined.push(`(${filterValues.join(" or ")})`)
                        break;
                }
            }
        }
    });

    filterString = filterCombined.join(" " + join + " ");

    if (filterString.length === 0)
        return undefined;

    return filterString;
}